import React, { HTMLAttributes } from 'react'
import classNames from 'classnames'
import './index.less'

type SJFromItemProps = HTMLAttributes<HTMLDivElement> & {
  className?: string
  title: string
  titleWidth?: string
  thumb?: string
  arrow?: string // drop
  focus?: boolean
  status?: '' | 'warn' | 'error' | 'success'
  statusText?: string
  onClick?: () => void
}

const SJFormItem: React.FC<SJFromItemProps> = ({
  className,
  title,
  titleWidth,
  arrow,
  focus,
  status,
  statusText,
  children,
  onClick,
}) => {
  return (
    <div
      className={classNames(
        'sc-form-item',
        className,
        `${focus ? 'sc-form-item_focus' : ''}`,
        `${status ? `sc-form-item_${status}` : ''}`,
      )}
      onClick={onClick}
    >
      <div className="sc-form-item_title" style={{ width: titleWidth }}>
        {title}
      </div>
      <img className="sc-form-item_divider" src={require('./icon-divider.png')} alt=""></img>
      <div className="sc-form-item_content oneline">{children}</div>
      {arrow === 'drop' ? (
        <img className="sc-form-item_arrow" src={require('./icon-drop.png')} alt="" />
      ) : arrow ? (
        <img className="sc-form-item_arrow" src={arrow} alt="" />
      ) : undefined}
      {status && statusText ? (
        <div className={`sc-form-item_${status}_text`}>{statusText}</div>
      ) : undefined}
    </div>
  )
}

export default SJFormItem
